import { EpimsBankDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as EpimsBankActions from './bank.actions';

export const BANK_FEATURE_KEY = 'bank';

export interface EpimsBankState extends EntityState<EpimsBankDto> {
  selectedEpimsBankId?: string | number; // which EpimsBank record has been selected
  loaded: boolean; // has the EpimsBank list been loaded
  error?: string | null; // last none error (if any)
}

export interface EpimsBankPartialState {
  readonly [BANK_FEATURE_KEY]: EpimsBankState;
}

export const bankAdapter: EntityAdapter<EpimsBankDto> = createEntityAdapter<
  EpimsBankDto
>({
  selectId: (bank) => bank.id,
  sortComparer: false,
});

export const initialState: EpimsBankState = bankAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedEpimsBankId: null,
});

const bankReducer = createReducer(
  initialState,
  on(EpimsBankActions.loadEpimsBank, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(EpimsBankActions.loadEpimsBankSuccess, (state, { bank }) =>
    bankAdapter.addAll(bank, { ...state, loaded: false })
  ),
  on(EpimsBankActions.loadEpimsBankFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(EpimsBankActions.addEpimsBank, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(EpimsBankActions.addEpimsBankSuccess, (state, { newEpimsBank }) =>
    bankAdapter.addMany(newEpimsBank, { ...state, loaded: false })
  ),
  on(EpimsBankActions.addEpimsBankFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(EpimsBankActions.updateEpimsBank, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(EpimsBankActions.updateEpimsBankSuccess, (state, { updateEpimsBank }) =>
    bankAdapter.upsertMany(updateEpimsBank, { ...state, loaded: false })
  ),
  on(EpimsBankActions.updateEpimsBankFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(EpimsBankActions.removeEpimsBank, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(EpimsBankActions.removeEpimsBankSuccess, (state, { ids }) =>
    bankAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(EpimsBankActions.removeEpimsBankFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: EpimsBankState | undefined, action: Action) {
  return bankReducer(state, action);
}
